import { useMutation } from '@tanstack/react-query';

import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

import { toastRuntimeError } from '@/shared/utils';
import { CreateCampaign, type CreateCampaignRequest } from '..';
import { useInvalidateAllCampaigns } from './use-invalidate-all-campaigns';

export function useCreateCampaign() {
  const { workspaceId } = useWorkspaceId();
  const invalidateAllCampaigns = useInvalidateAllCampaigns();

  return useMutation({
    mutationFn: (request: CreateCampaignRequest) => CreateCampaign(workspaceId, request),
    onSuccess: async () => {
      await invalidateAllCampaigns();
    },
    onError: (e) => {
      toastRuntimeError(e, 'Failed to create campaign. Please try again.');
    },
  });
}
